import { render, staticRenderFns } from "./SelectPaymentGateway.vue?vue&type=template&id=3a6a5019&"
import script from "./SelectPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaymentGateway.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports